import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import MobileTopBar from "./components/MobileTopBar";
import AuthGate from "./components/AuthGate";
import AdminGate from "./components/AdminGate";
import { ShellProvider } from "./lib/shell";
import ErrorBoundary from "./components/ErrorBoundary";
import { ToastProvider, ToastHost } from "./lib/toast";
import LoginView from "./views/LoginView";
import SignupView from "./views/SignupView";
import VerifyEmailView from "./views/VerifyEmailView";
import ForgotPasswordView from "./views/ForgotPasswordView";
import ResetPasswordView from "./views/ResetPasswordView";
import AdminUsersView from "./views/AdminUsersView";
import ChatView from "./views/ChatView";
import SearchView from "./views/SearchView";
import ProjectsView from "./views/ProjectsView";
import ProjectDetailView from "./views/ProjectDetailView";
import WikiView from "./views/WikiView";
import MemoryView from "./views/MemoryView";
import SkillsView from "./views/SkillsView";
import PluginsView from "./views/PluginsView";
import MCPView from "./views/MCPView";
import ResearchView from "./views/ResearchView";
import ImagesView from "./views/ImagesView";
import PublishedSitesView from "./views/PublishedSitesView";
import SettingsView from "./views/SettingsView";
import "./App.css";

export default function App() {
  return (
    <ToastProvider>
      <ShellProvider>
      <ErrorBoundary>
        <Routes>
          <Route path="/login" element={<LoginView />} />
          <Route path="/signup" element={<SignupView />} />
          <Route path="/verify-email" element={<VerifyEmailView />} />
          <Route path="/forgot-password" element={<ForgotPasswordView />} />
          <Route path="/reset-password" element={<ResetPasswordView />} />
          <Route
            path="*"
            element={
              <AuthGate>
                <div className="app-shell">
                  <Sidebar />
                  <main className="app-main">
                    <MobileTopBar />
                    <Routes>
                      <Route path="/" element={<ChatView />} />
                      <Route path="/chat/:chatId" element={<ChatView />} />
                      <Route path="/search" element={<SearchView />} />
                      <Route path="/projects" element={<ProjectsView />} />
                      <Route path="/projects/:projectId" element={<ProjectDetailView />} />
                      <Route path="/projects/:projectId/wiki" element={<WikiView />} />
                      <Route path="/projects/:projectId/wiki/:pageId" element={<WikiView />} />
                      <Route path="/memory" element={<MemoryView />} />
                      <Route path="/skills" element={<SkillsView />} />
                      <Route path="/plugins" element={<PluginsView />} />
                      <Route path="/mcp" element={<MCPView />} />
                      <Route path="/research" element={<ResearchView />} />
                      <Route path="/images" element={<ImagesView />} />
                      <Route path="/published" element={<PublishedSitesView />} />
                      <Route path="/settings" element={<SettingsView />} />
                      <Route path="/admin/users" element={<AdminGate><AdminUsersView /></AdminGate>} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </main>
                </div>
              </AuthGate>
            }
          />
        </Routes>
      </ErrorBoundary>
      </ShellProvider>
      <ToastHost />
    </ToastProvider>
  );
}